import Staff from "./staff/staff_away.store";
import Teacher from "./teacher/teacher_away.store";

export default {
  modules: { Staff, Teacher },
};
